export default {
    contactUs: "Contact Us",
    aboutUs: "About Us",
    loremIpsum: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum quis consectetur odio. Donec arcu turpis, mollis sit amet blandit sit amet, rutrum sit amet ex.",
    products: "Products",
    link: "Link",
    italy: "Italy",
    or: "or"
}